<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg"><img src="assets/svg/name-icon.svg" alt=""></div>
      <div>
        <h4 class="text-semibold">Filtrar oportunidades</h4>
        <h6 class="color-gray" style="font-weight: 400;">Selecciona los criterios para filtrar la vista de oportunidades.</h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt="">
          </div>
        </h3>
      </div>
    </div>

    <form>
      <div class="filter-section">
        <label class="section-title">Etapa de la oportunidad</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allStages" name="allStages" (change)="toggleAllStages()">
            <span class="crm-checkbox-custom"></span>
            Todas las etapas
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.stages.prospeccion" name="prospeccion" (change)="onStageChange()">
            <span class="crm-checkbox-custom"></span>
            Prospección
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.stages.calificacion" name="calificacion" (change)="onStageChange()">
            <span class="crm-checkbox-custom"></span>
            Calificación
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.stages.propuesta" name="propuesta" (change)="onStageChange()">
            <span class="crm-checkbox-custom"></span>
            Propuesta
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.stages.negociacion" name="negociacion" (change)="onStageChange()">
            <span class="crm-checkbox-custom"></span>
            Negociación
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.stages.cerradaGanada" name="cerradaGanada" (change)="onStageChange()">
            <span class="crm-checkbox-custom"></span>
            Cerrada Ganada
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.stages.cerradaPerdida" name="cerradaPerdida" (change)="onStageChange()">
            <span class="crm-checkbox-custom"></span>
            Cerrada Perdida
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Tipo de negocio</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allTypes" name="allTypes" (change)="toggleAllTypes()">
            <span class="crm-checkbox-custom"></span>
            Todos los tipos
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.types.nuevoNegocio" name="nuevoNegocio" (change)="onTypeChange()">
            <span class="crm-checkbox-custom"></span>
            Nuevo negocio
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.types.negocioExistente" name="negocioExistente" (change)="onTypeChange()">
            <span class="crm-checkbox-custom"></span>
            Negocio existente
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.types.renovacion" name="renovacion" (change)="onTypeChange()">
            <span class="crm-checkbox-custom"></span>
            Renovación
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Probabilidad de cierre</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allProbabilities" name="allProbabilities" (change)="toggleAllProbabilities()">
            <span class="crm-checkbox-custom"></span>
            Todas las probabilidades
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.probabilities.baja" name="baja" (change)="onProbabilityChange()">
            <span class="crm-checkbox-custom"></span>
            Baja (0-33%)
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.probabilities.media" name="media" (change)="onProbabilityChange()">
            <span class="crm-checkbox-custom"></span>
            Media (34-66%)
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.probabilities.alta" name="alta" (change)="onProbabilityChange()">
            <span class="crm-checkbox-custom"></span>
            Alta (67-100%)
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Rango de importe</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="amountRange" [(ngModel)]="filters.amountRange" value="all">
            <span class="crm-radio-custom"></span>
            Todos los importes
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="amountRange" [(ngModel)]="filters.amountRange" value="0-1000000">
            <span class="crm-radio-custom"></span>
            $0 - $1.000.000
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="amountRange" [(ngModel)]="filters.amountRange" value="1000001-5000000">
            <span class="crm-radio-custom"></span>
            $1.000.001 - $5.000.000
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="amountRange" [(ngModel)]="filters.amountRange" value="5000001-10000000">
            <span class="crm-radio-custom"></span>
            $5.000.001 - $10.000.000
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="amountRange" [(ngModel)]="filters.amountRange" value="10000001+">
            <span class="crm-radio-custom"></span>
            Más de $10.000.000
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Fecha de cierre</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="closingDateRange" [(ngModel)]="filters.closingDateRange" value="all">
            <span class="crm-radio-custom"></span>
            Todas las fechas
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="closingDateRange" [(ngModel)]="filters.closingDateRange" value="7d">
            <span class="crm-radio-custom"></span>
            Próximos 7 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="closingDateRange" [(ngModel)]="filters.closingDateRange" value="30d">
            <span class="crm-radio-custom"></span>
            Próximos 30 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="closingDateRange" [(ngModel)]="filters.closingDateRange" value="pasadas">
            <span class="crm-radio-custom"></span>
            Fechas pasadas
          </label>
        </div>
      </div>

      <div *ngIf="ejecutivos.length > 0">
        <label>Ejecutivo</label>
        <div class="crm-input">
          <select class="crm-input" name="ejecutivoId" [(ngModel)]="filters.ejecutivoId">
            <option value="all">Todos</option>
            <option *ngFor="let e of ejecutivos" [value]="e.usuario_id">
              {{ e.nombreCompleto }}
            </option>
          </select>
        </div>
      </div>
      

      <hr style="margin-top: 24px;">

      <div class="filter-actions">
        <button type="button" class="btn btn-primary-outline" (click)="closeMdl()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="applyFilters()">Aplicar filtros</button>
      </div>
    </form>
  </div>
</div>